import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SvgIconPropsType, SvgIconSpinner } from 'src/ui/assets/icons/utils';

export const LoadingIcon = observer('CloseIcon', ({ className, onClick }: SvgIconPropsType): JSX.Element => {
    return (
        <SvgIconSpinner
            className={className}
            onClick={onClick}
            fillRule='evenodd'
            height='24'
            viewBox='0 0 24 24'
            width='24'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fill='currentcolor'
                d='M12 2A10 10 0 1 1 2 12h2a8 8 0 1 0 8-8V2Z'
            />
        </SvgIconSpinner>
    );
});
